import { sendCustomError as apmSendCustomError } from "@otto-ec/global-resources/apm";
import { getVersion } from "./Version";

export type SendCustomErrorLabels = { [K in string]: LabelValue };
export function sendCustomError(namespace: string, message: string | Error, labels?: SendCustomErrorLabels): void {
    apmSendCustomError(namespace, message, { ...labels, version: getVersion() ?? "" });
}
